<template>
  <div class="giftticket-result absolute">
    <div class="result-title" v-if="list.length > 1">
      <tabs type="card" @click="onClick">
        <tab
          :title="'第' + index + '次提货'"
          v-for="index in list.length"
          :key="index"
          :name="index"
        ></tab>
      </tabs>
    </div>
    <div :class="list.length > 1 ? 'whiteBg2' : 'whiteBg'">
      <div class="nav acea-row">
        <div class="item font-color-red" v-if="info.status === 1">
          预约中，请耐心等待商家确认...
        </div>
        <div class="item font-color-red" v-else-if="info.status === 2">
          预约成功，等待商家发货！
        </div>
        <div class="item font-color-red" v-else-if="info.status === 3">
          已发货，很快就能收到货哦！
        </div>
        <div class="item font-color-red" v-else-if="info.status === 4">
          已完成，欢迎下次惠顾！
        </div>
      </div>
      <div
        class="list"
        v-if="
          info.status === 1 ||
            info.status === 2 ||
            info.status === 3 ||
            info.status === 4
        "
      >
        <div class="item acea-row row-between-wrapper">
          <div class="result-label">卡号：</div>
          <div class="result-value">{{ info.code }}</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="result-label">姓名：</div>
          <div class="result-value">{{ info.contactName }}</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="result-label">联系方式：</div>
          <div class="result-value">{{ info.contactWay }}</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="result-label">收货地址：</div>
          <div class="result-value">{{ info.detail }}</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="result-label">期望发货日期：</div>
          <div class="result-value" v-if="info.date">{{ info.date }}</div>
          <div class="result-value" v-else>
            无
            <span class="font-color-red">（预计7天内发货）</span>
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="result-label">预约时间：</div>
          <div class="result-value">{{ info.appointmentTime }}</div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="result-label">备注：</div>
          <div class="result-value">{{ info.remark }}</div>
        </div>
        <div class="item acea-row row-between-wrapper" v-if="info.merchantRemark">
          <div class="result-label">商家备注：</div>
          <div class="result-value">{{ info.merchantRemark }}</div>
        </div>

        <div class="result-express" v-if="info.status === 3">
          <div class="item acea-row row-between-wrapper">
            <div class="result-label">快递名称：</div>
            <div class="result-value">{{ info.expressName }}</div>
          </div>
          <div class="item acea-row row-between-wrapper">
            <div class="result-label">快递单号：</div>
            <div class="result-value">{{ info.expressNo }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<script>
import { getResult } from "@api/giftticket";
import { Tab, Tabs } from "vant";

export default {
  name: "GiftTicketResult",
  components: { Tab, Tabs },
  data: function() {
    return {
      code: "",
      list: [],
      info: {},
      index: 0
    };
  },
  mounted: function() {
    this.code = this.$route.params.code;
    this.index = 0;
    this.getData();
  },
  methods: {
    getData() {
      getResult(this.code)
        .then(res => {
          if (res.data.status === false) {
            this.$dialog.toast({ mes: "未查询到提货信息" });
            this.$router.push({ path: "/giftticket/subscribe" });
          } else {
            this.list = res.data.info;
            this.info = res.data.info[0];
          }
        })
        .catch(err => {
          this.$dialog.error(err.msg);
          setTimeout(() => {
            this.$router.push({ path: "/giftticket/subscribe" });
          }, 2000);
        });
    },
    onClick(name, title) {
      this.info = this.list[name - 1];
    }
  }
};
</script>
